export default __webpack_public_path__ + "static/media/logo_globe.f3d73a2a.png";